"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentMethods = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getPaymentMethods(_a) {
    var where = _a.where, orderBy = _a.orderBy, skip = _a.skip, take = _a.take;
    var variables = {
        where: where,
        orderBy: orderBy,
        skip: skip,
        take: take,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query(\n        $where: PaymentMethodWhereInput\n        $orderBy: [PaymentMethodOrderByInput!]\n        $take: Int\n        $skip: Int\n      ) {\n        paymentMethods(\n          where: $where\n          orderBy: $orderBy\n          take: $take\n          skip: $skip\n        ) {\n          id\n        }\n      }\n    "], ["\n      query(\n        $where: PaymentMethodWhereInput\n        $orderBy: [PaymentMethodOrderByInput!]\n        $take: Int\n        $skip: Int\n      ) {\n        paymentMethods(\n          where: $where\n          orderBy: $orderBy\n          take: $take\n          skip: $skip\n        ) {\n          id\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getPaymentMethods = getPaymentMethods;
var templateObject_1;
